import React from "react";

const PrivySvg = ({...props}) => {
  return (
    <svg
      width="191"
      height="59"
      viewBox="0 0 191 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.312 26.8858L138.745 26.9354L129.493 6.18129L120.85 6.9375L120.927 7.82227L133.951 36.796L145.431 35.7917L153.229 4.9962L153.152 4.11143L144.884 4.83474L139.309 26.8861L139.312 26.8858Z"
        fill="#CFB2FF"
      />
      <path
        d="M118.544 7.13867L109.949 7.89062L112.641 38.6566L121.236 37.9046L118.544 7.13867Z"
        fill="#CFB2FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.681 1.86952L178.688 1.86895L173.113 23.9268L172.546 23.9764L163.293 3.21902L154.65 3.97523L154.728 4.86648L168.876 36.3447L158.168 37.2815L158.792 44.4082L169.256 43.4927C173.726 43.1017 177.075 41.2901 178.342 36.3329C178.513 35.6713 187.026 2.03421 187.026 2.03421L186.948 1.14296L178.681 1.86628L178.681 1.86952Z"
        fill="#CFB2FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0793 10.884C62.1707 11.2259 58.6923 13.5354 56.7412 17.4747L56.2129 17.5209L55.7876 12.6596L47.5945 13.3764L51.1329 53.8197L59.838 53.0581L58.646 39.4333L59.1807 39.3865C59.2461 39.4625 59.3118 39.5416 59.3761 39.6046C61.0005 41.2619 64.6676 43.6843 68.9326 43.3111C76.6946 42.632 81.4163 35.4589 80.5849 25.9565C79.7536 16.4542 73.5949 10.2264 66.0793 10.884ZM65.7336 36.8701C61.6825 37.2246 58.6094 34.3126 58.0511 27.9313C57.4928 21.5499 60.0136 18.1486 64.0647 17.7941C68.1158 17.4397 71.331 20.4078 71.8833 26.7211C72.4357 33.0344 69.8528 36.5098 65.7336 36.8701Z"
        fill="#CFB2FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.831 8.68368C96.7957 9.03669 94.2652 9.93736 93.1212 14.2927L92.6026 14.338L92.1745 9.44427L79.7132 10.5345L80.3313 17.5997L83.112 17.3564C84.0292 17.2762 84.508 17.5608 84.6905 18.3025L85.2043 24.1751L85.2367 24.1722L86.7026 40.9277L95.4077 40.1661L93.9797 23.8449C93.61 19.6188 94.5307 16.9289 98.7569 16.5592L107.877 15.7613L107.209 8.12567L100.834 8.6834L100.831 8.68368Z"
        fill="#CFB2FF"
      />
      <path
        d="M19.5976 47.6164C28.5458 46.8335 35.1673 38.9423 34.3844 29.9941C33.6016 21.046 25.7103 14.4244 16.7622 15.2073C7.81402 15.9901 1.19247 23.8814 1.97533 32.8296C2.75819 41.7777 10.6494 48.3993 19.5976 47.6164Z"
        fill="#CFB2FF"
      />
      <path
        d="M20.4193 57.038C26.5349 56.5029 31.4022 55.0255 31.2902 53.7454C31.1782 52.4652 26.1315 51.8552 20.0127 52.3905C13.8938 52.9258 9.02978 54.4029 9.14178 55.6831C9.25378 56.9633 14.3004 57.5733 20.4193 57.038Z"
        fill="#CFB2FF"
      />
    </svg>
  );
};

export default PrivySvg;
